var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.7,119.2c-9.4,0-18.4-3-25.9-8.6c-1.3-1-1.5-2.7-0.5-4c1-1.2,2.8-1.5,4.1-0.5c6.5,4.8,14.2,7.4,22.3,7.4c0,0,0,0,0,0 c8.2,0,15.9-2.6,22.3-7.4c1.3-1,3.1-0.7,4.1,0.5c1,1.2,0.7,3-0.5,4C100.1,116.2,91.1,119.2,81.7,119.2L81.7,119.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5c37.8,0,68.5,30.7,68.5,68.5 C146.5,115.8,115.8,146.5,78,146.5z M78,14.3c-35.1,0-63.7,28.6-63.7,63.7c0,35.1,28.6,63.7,63.7,63.7s63.7-28.6,63.7-63.7 C141.7,42.9,113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,56.1c0.4-1.2,1.6-1.6,2.7-0.8c3,2.2,6.8,2.7,11.4,1.2c1-0.3,2.2,0.6,2.7,2c0.4,1.4,0,2.8-1.1,3.2 c-5.5,1.7-10.3,1.2-14.5-1.9C98.5,58.9,98,57.3,98.5,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2,56.1c-0.4-1.2-1.6-1.6-2.7-0.8c-3,2.2-6.8,2.7-11.4,1.2c-1-0.3-2.2,0.6-2.7,2c-0.4,1.4,0,2.8,1.1,3.2 c5.5,1.7,10.3,1.2,14.5-1.9C65.1,58.9,65.6,57.3,65.2,56.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress3);
export default __webpack_public_path__ + "static/media/Stress3.473f2e1c9a6ed5e78589a9b0ea301a91.svg";
export { ForwardRef as ReactComponent };